import {useEffect, useRef, useState} from "react";

export type UseAutoCloseOnSuccessProps = {
  enabled: boolean;
  seconds: number;
  onClose: () => void;
}

export const useAutoCloseOnSuccess = (props: UseAutoCloseOnSuccessProps) => {
  const {enabled, seconds, onClose} = props;
  const [remainingMs, setRemainingMs] = useState(seconds * 1000);
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    if (!enabled) {
      setRemainingMs(seconds * 1000);
      return;
    }

    const started = Date.now();

    timerRef.current = window.setInterval(() => {
      const elapsed = Date.now() - started;
      const left = Math.max(0, seconds * 1000 - elapsed);
      setRemainingMs(left);

      if (left === 0) {
        if (timerRef.current) window.clearInterval(timerRef.current);
        timerRef.current = null;
        onClose();
      }
    }, 100);

    return () => {
      if (timerRef.current) window.clearInterval(timerRef.current);
      timerRef.current = null;
    };
  }, [enabled, seconds, onClose]);

  const progress = 100 - Math.round((remainingMs / (seconds * 1000)) * 100);

  return {remainingMs, progress, cancel: () => setRemainingMs(seconds * 1000)};
}
